import React from "react";

import { i18, trb } from "@utilities";
import {
  InputFormField,
  RadioFormField,
  CheckboxFormField
} from "@components/FormField/HookFormFields";
import { FullWidthInputWrapper, StepperFormRow } from "@components";
import { yesNo } from "@config/StepperForm";
import { useWatch } from "react-hook-form";

export const TradeSecure = ({ control, resetIsinCode }) => {
  const tradeSecure = useWatch({ control, name: "clientBeneficiaries.0.data.tradeSecur" });
  return (
    <StepperFormRow>
      <FullWidthInputWrapper>
        <p className="form-group-title">{trb(i18.Labels.ClientBeneficiaries)}</p>
      </FullWidthInputWrapper>

      <FullWidthInputWrapper>
        <p className="form-part-description mb-3">
          {trb(i18.Messages.ClientBenefecariesNoteAfter)}
        </p>
      </FullWidthInputWrapper>

      <FullWidthInputWrapper>
        <RadioFormField
          control={control}
          name="clientBeneficiaries.0.data.tradeSecur"
          title={trb(i18.Labels.TradeSecur)}
          options={yesNo}
          optionsLabel="label"
          optionsValue="value"
          onChange={resetIsinCode}
          translationGroup={i18.Labels}
          defaultValue={0}
        />
      </FullWidthInputWrapper>

      {(tradeSecure === 1 || tradeSecure === "1") && (
        <>
          <FullWidthInputWrapper>
            <InputFormField
              control={control}
              name="clientBeneficiaries.0.data.isinCode"
              title={trb(i18.Labels.IsinCode)}
            />
          </FullWidthInputWrapper>
          <FullWidthInputWrapper>
            <p className="form-part-description mb-3">{trb(i18.Messages.ClientBenefecariesNote)}</p>
          </FullWidthInputWrapper>
        </>
      )}
      <FullWidthInputWrapper>
        <CheckboxFormField
          control={control}
          name="clientBeneficiaries.0.data.uboretail"
          label={trb(i18.Labels.Uboretail)}
        />
      </FullWidthInputWrapper>
    </StepperFormRow>
  );
};
